module.exports = __webpack_public_path__ + "img/logo.2b76d410.svg";